import React from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";

import DashboardContainer from "../pages/Dashboard";
import OrganizationList from "../pages/OrganizationList";
import CreateOrganization from "../pages/CreateOrganization";
import UsersList from "../pages/UsersList";
import CreateUser from "../pages/CreateUsers";
import OrganizationDetails from "../pages/OrganizationDetails";
import AgentsList from "../pages/AgentsList";
import CreateAgent from "../pages/CreateAgent";
import AgentEarnings from "../pages/AgentEarnings";
import Profile from "../pages/Profile";
import AgentMerchantsDetails from "../pages/AgentMerchantsDetails";
import MerchantProfile from "../pages/MerchantProfile";
import MerchantTransactions from "../pages/MerchantTransactions ";
import Transactions from "../pages/Transactions";
import Analytics from "../pages/Analytics";
import Settings from "../pages/Settings";

function DashboardLayout() {
  const location = useLocation();
  console.log("location", location);
  // derive title from current route
  let pageTitle = "Dashboard";
  let showBack = false;
  let mode = "create";
  if (location.pathname.includes("organizationlist")) {
    pageTitle = "All Organizations";
  } else if (location.pathname.includes("OrganizationDetails")) {
    const { name } = location.state || {};
    pageTitle = name || "Organization Stats";
    showBack = true;
  } else if (location.pathname.includes("organization")) {
    const params = new URLSearchParams(location.search);
    mode = params.get("mode") || "create";
    showBack = true;
    if (mode === "edit") pageTitle = "Edit Organization";
    else if (mode === "view") pageTitle = "View Organization";
    else pageTitle = "Organization Onboarding";
  } else if (location.pathname.includes("userslist")) {
    pageTitle = "All Users";
  } else if (location.pathname.includes("user")) {
    const params = new URLSearchParams(location.search);
    mode = params.get("mode") || "create";
    showBack = true;
    if (mode === "edit") pageTitle = "Edit User";
    else if (mode === "view") pageTitle = "View User";
    else pageTitle = "Add New User";
  } else if (location.pathname.includes("agentslist")) {
    pageTitle = "All Agents";
  } else if (location.pathname.includes("agent-earnings")) {
    const { name } = location.state || {};
    showBack = true;
    pageTitle = name || "Agent Earning";
  } else if (location.pathname.includes("agent")) {
    const params = new URLSearchParams(location.search);
    mode = params.get("mode") || "create";
    showBack = true;
    if (mode === "edit") pageTitle = "Edit Agent";
    else if (mode === "view") pageTitle = "View Agent";
    else pageTitle = "Add New Agent";
  }
  else if(location.pathname.includes("merchantprofile")){
    const { name } = location.state || {};
    showBack = true;
    pageTitle = name || "Agent Earning";
  } else if (location.pathname.includes("transactions")) {
    pageTitle = "Transactions";
  } else if (location.pathname.includes("analytics")) {
    pageTitle = "Analytics";
  } else if (location.pathname.includes("settings")) {
    pageTitle = "Settings";
  }else if(location.pathname.includes("profile")){
    pageTitle = "User Profile";
  }else if(location.pathname.includes("merchantsdetails")){
    const { name } = location.state || {};
    showBack = true;
    pageTitle = name || "Merchants details";
  }else if(location.pathname.includes("merchant-transactions")){
    const { name } = location.state || {};
    showBack = true;
    pageTitle = name || "Merchant Transactions";
  }

  return (
    <div className="dashboard-layout">
      <Sidebar isOpen={true} />

      <div className="dashboard-main">
        <Navbar title={pageTitle} showBack={showBack} />

        <div className="dashboard-content">
          {location.pathname.includes("organizationlist") ? (
            <OrganizationList isSidebarOpen={true} />
          ) : location.pathname.includes("organization") ? (
            <CreateOrganization isSidebarOpen={true} mode={mode} />
          ) : location.pathname.includes("userslist") ? (
            <UsersList isSidebarOpen={true} />
          ) : location.pathname.includes("transactions") ? (
            <Transactions isSidebarOpen={true} />
          ) : location.pathname.includes("analytics") ? (
            <Analytics isSidebarOpen={true} />
          ) : location.pathname.includes("settings") ? (
            <Settings isSidebarOpen={true} />
          ) : location.pathname.includes("user") ? (
            <CreateUser isSidebarOpen={true} mode={mode} />
          ) : location.pathname.includes("OrganizationDetails") ? (
            <OrganizationDetails isSidebarOpen={true} />
          ) : location.pathname.includes("agentslist") ? (
            <AgentsList isSidebarOpen={true} />
          ) : location.pathname.includes("agent-earnings") ? (
            <AgentEarnings isSidebarOpen={true} />
          ): location.pathname.includes("merchantsdetails") ? (
            <AgentMerchantsDetails isSidebarOpen={true} />
          ): location.pathname.includes("merchant-transactions") ? (
            <MerchantTransactions isSidebarOpen={true} />
          ) : location.pathname.includes("agents") ? (
            <CreateAgent isSidebarOpen={true} mode={mode} />
          ):location.pathname.endsWith("/merchantprofile") ? ( // FIX
            <MerchantProfile isSidebarOpen={true} mode={mode} />
          ) :location.pathname.endsWith("/profile") ? ( // FIX
            <Profile isSidebarOpen={true} mode={mode} />
          ): (
            <DashboardContainer isSidebarOpen={true} />
          )}
        </div>
      </div>
    </div>
  );
}

export default DashboardLayout;
